/**
 * Created by Ning Jiang on 4/19/2016.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {DevConsole} from "@nolimitcity/slot-launcher/bin/devtools/DevConsole";
import {IServerController} from "@nolimitcity/slot-game/bin/core/server/ServerController";
import {WGServerDataParser} from "../WGServerDataParser";
import {IBlankGameData, IBlankInitData} from "./IBlankServerData";
import {WGParsedGameData} from "./WGParsedGameData";
import {WGParsedInitData} from "./WGParsedInitData";

export class WarriorGraveyardServerController implements IServerController {
    private _initComplete: boolean = false;
    /**
     * data is the latest data received.
     */
    public get data(): any {
        return this._latestData;
    }

    public get initData(): any {
        return this._parsedInitData;
    }

    public get gameData(): any {
        return this._parsedGameData;
    }

    protected readonly _dataParser: WGServerDataParser;
    private _parsedInitData: WGParsedInitData;
    private _parsedGameData: WGParsedGameData;
    private _latestData: WGParsedInitData | WGParsedGameData;

    constructor() {
        this._dataParser = new WGServerDataParser();
        EventHandler.addLastEventListener(this, ServerEvent.INIT_DATA_RECEIVED, (event:GameEvent) => this.onInitDataReceived(event.params[0]));
        EventHandler.addLastEventListener(this, ServerEvent.GAME_DATA_RECEIVED, (event:GameEvent) => this.onGameDataReceived(event.params[0]));

        DevConsole.addCommand("printLatestData", () => {console.log(this.data)});
        DevConsole.addCommand("printGameData", () => {console.log(this.gameData)});
        DevConsole.addCommand("printInitData", () => {console.log(this.initData)});
    }

    private onInitDataReceived(data:IBlankInitData):void {
        this._parsedInitData = new WGParsedInitData(data, this._dataParser);
        this._latestData = this._parsedInitData;
        this.tryDispatchInitParsed();
        EventHandler.removeLastEventListener(this, ServerEvent.INIT_DATA_RECEIVED);
    }

    private onGameDataReceived(data:IBlankGameData):void {
        this._parsedGameData = new WGParsedGameData(data, this._dataParser);
        this._latestData = this._parsedGameData;
        EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_PARSED, this.gameData));
    }

    public initComplete() {
        this._initComplete = true;
        this.tryDispatchInitParsed();
    }

    private tryDispatchInitParsed() {
        if (this._initComplete && this._parsedInitData != undefined){
            EventHandler.dispatchEvent(new GameEvent(ServerEvent.INIT_DATA_PARSED, this.initData));
        }
    }
}